import { render, staticRenderFns } from "./LFixedWindow.vue?vue&type=template&id=4dc7997b&scoped=true"
import script from "./LFixedWindow.vue?vue&type=script&lang=js"
export * from "./LFixedWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc7997b",
  null
  
)

export default component.exports